'use client';

import { IMSLayout } from '@sgcmpteltd/uikit-next';
import Image from 'next/image';

import { SystemLogo } from '../(protected)/_components/page-content/system-logo';
import { env } from '@/app/env';

import { useMediaQuery } from '@/hooks/use-media-query';

const PublicPagesWithHeaderLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isDesktop = useMediaQuery({
    breakpoint: 1140,
  });
  return (
    <IMSLayout
      authenticated={false}
      customTheme={{
        desktop: { backgroundColor: 'white', userSectionColor: 'black' },
        mobile: { backgroundColor: '#F8F8F8', contentColor: 'black' },
      }}
      headerLogoSection={
        isDesktop
          ? (
              <SystemLogo />
            )
          : (
              <Image
                alt="sgcarmart"
                height={17}
                src={`${env.NEXT_PUBLIC_SGCM_IMAGE_MEDIA_URL}/ims/default/sgcm-logo.svg`}
                width={153}
              />
            )
      }
    >
      {children}
    </IMSLayout>
  );
};

export default PublicPagesWithHeaderLayout;
